// Static version tracker for the SPY Long/Short ITM Signal Strategy
// (backend/cmd/spylongshort). Same pattern/conventions as
// StrategyVersionTracker.js (SPY RSI Strategy) - manually maintained,
// updated in the same turn a rule changes and is re-backtested.
//
// Unlike the RSI/EMA strategies, these rules were not specified upfront -
// they were discovered by a 36-combo grid search per side (6 candidate
// entries x 6 candidate exits, built from RSI/MACD/EMA20/EMA200/ATR) over
// 6 months of SPY 5-min bars, ranked by total ATR-normalized R-multiple.
const CONDITIONS = [
  { text: 'Indicators computed on SPY 5-min chart: 20 EMA, 200 EMA, RSI(14, Wilder), MACD(12,26,9), ATR(14, Wilder)', addedAt: '2026-07-15' },
  { text: 'Regime filter: Long signals only considered while 20 EMA > 200 EMA; Short signals only considered while 20 EMA < 200 EMA', addedAt: '2026-07-15' },
  { text: 'Long entry: RSI(14) crosses up through 50 while in bullish regime → buy an ITM call', addedAt: '2026-07-15' },
  { text: 'Long exit: a 5-min candle closes below the 20 EMA → sell the call', addedAt: '2026-07-15' },
  { text: 'Short entry: MACD line crosses below the signal line while in bearish regime → buy an ITM put', addedAt: '2026-07-15' },
  { text: 'Short exit: MACD line crosses back above the signal line → sell the put', addedAt: '2026-07-15' },
  { text: 'Contract: weekly expiry, entered at 5-7 DTE; strike ~2 strikes in-the-money (call strike below spot, put strike above spot)', addedAt: '2026-07-15' },
  { text: 'Held contract is force-exited (rolled) if it drops to ≤1 DTE while a position is still open', addedAt: '2026-07-15' },
  { text: 'One position open at a time — Long and Short never held simultaneously', addedAt: '2026-07-15' },
  { text: 'No forced end-of-day exit — positions may carry overnight/multi-day (unlike the 0DTE strategies above)', addedAt: '2026-07-15' },
  { text: 'Starting budget $1,000 as one running total (not a per-trade cap); an unaffordable signal is skipped, not the whole day — $500 was tested first and proved too thin for weekly ITM contract prices', addedAt: '2026-07-15' },
  { text: '$7/contract flat round-trip cost', addedAt: '2026-07-15' },
];

const VERSIONS = [
  {
    name: 'Original Discovery',
    note: '2026-07-15 — winner by SPY-points R-multiple (Long PF 1.68, Short PF 1.07), but real $ result over 6mo/$1,000 was net -$555 (Long -$743, Short +$188) — the SPY-points ranking did NOT predict real option P&L, see chat for why',
    has: new Set([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  },
];

export default function SpyLongShortStrategyVersionTracker() {
  return (
    <div className="bg-gray-900 rounded-2xl p-5 mb-5">
      <div className="flex items-center gap-3 mb-1 flex-wrap">
        <span className="text-xs font-bold px-3 py-1.5 rounded border"
          style={{ backgroundColor: '#111827', color: '#e5e7eb', borderColor: '#374151' }}>
          SPY Long/Short ITM Signal Strategy — Version Tracker
        </span>
      </div>
      <div className="text-xs text-gray-500 mb-3">
        Manually maintained record of which rules each backtest version ran with. Green check = rule active in that version, red X = not active.
        Rules were discovered empirically (grid search), not specified upfront — see backend/cmd/spylongshort for the full candidate list tested.
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-xs" style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr className="text-gray-500 border-b" style={{ borderColor: '#1f2937' }}>
              <th className="py-2 pr-3 text-left font-medium" style={{ width: 36 }}>#</th>
              <th className="py-2 pr-3 text-left font-medium">Condition</th>
              {VERSIONS.map((v) => (
                <th key={v.name} className="py-2 px-3 text-center font-medium" style={{ minWidth: 120 }}>
                  <div className="text-gray-300">{v.name}</div>
                  <div className="text-[10px] font-normal text-gray-600 normal-case">{v.note}</div>
                </th>
              ))}
              <th className="py-2 pl-3 text-right font-medium" style={{ minWidth: 90 }}>Added</th>
            </tr>
          </thead>
          <tbody>
            {CONDITIONS.map((cond, i) => (
              <tr key={i} className="border-b" style={{ borderColor: '#1f2937' }}>
                <td className="py-2 pr-3 text-gray-500 font-mono">{i + 1}</td>
                <td className="py-2 pr-3 text-gray-300">{cond.text}</td>
                {VERSIONS.map((v) => (
                  <td key={v.name} className="py-2 px-3 text-center font-bold" style={{ color: v.has.has(i) ? '#22c55e' : '#ef4444' }}>
                    {v.has.has(i) ? '✓' : '✗'}
                  </td>
                ))}
                <td className="py-2 pl-3 text-right text-gray-500 font-mono">{cond.addedAt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
